export default __webpack_public_path__ + "static/media/barba.e7e77e27.png";